import * as React from "react";
import { IIdleTimer } from "react-idle-timer";

interface IdleTimerContextState {
    timer: IIdleTimer;
}

interface IdleTimerContextProviderProps {
    timer: IIdleTimer;
    children: React.ReactNode;
}

export const IdleTimerContext = React.createContext<IdleTimerContextState | undefined>(undefined);

export const IdleTimerContextProvider = ({ timer, children }: IdleTimerContextProviderProps) => {
    return (
        <IdleTimerContext.Provider value={{
            timer: timer,
        }}>
            {children}
        </IdleTimerContext.Provider>
    )
}

export const useIdleTimerContext = (): IdleTimerContextState => {
    const context = React.useContext(IdleTimerContext);
    if (context === undefined) {
        throw new Error('useIdleTimerContext must be used within a IdleTimerContext Provider');
    }

    return context;
}
